import React, { useContext } from "react";
import "./homePage.css";
import { Theme } from "../App";
import { FaGithub, FaLinkedin, FaLinkedinIn } from "react-icons/fa";


function HomePage() {
  const { theme, setTheme } = useContext(Theme);

  return (
    <div id="homepage-comp" className={`homepage-comp-${theme}`}>
      <div className={`hero-text hero-text-${theme}`}>
        <span><h1>Hey There <img src="./waving.png" alt="" /></h1><h1>I'm <span style={{color:'#10A37F'}}>ALI</span></h1></span>
        <p>And I'm a Full-Stack Developer &lt;/&gt;</p>
        <div className="social-links">
          <a href="https://github.com/Ali-Ishaq" target="blank"><FaGithub  size={'30px'}/></a>
          <a href="https://www.linkedin.com/in/ali-ishaq-2a070b2b7?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="blank"><FaLinkedin size={'30px'}/></a>
        </div>
      </div>
      <div className={`hero-image hero-image-${theme}`}>
        <img src="profile2.png" alt="" />
        <span className="profilebg"></span>
      </div>
    </div>
  );
}

export default HomePage;
